// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-list-items {
  margin: 0;
  padding: 0;
  margin-top: 10px;
}

.sidebar-list-item {
  list-style-type: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 14px;
  margin-right: 1rem !important;
}

.sidebar-list-icon {
  width: 15px;
  height: 15px;
  margin: 0 10px 0 10px;
}

.sidebar-list-icon--component {
  width: auto;
  height: auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.user-dropdown {
  width: 200px !important;
}

.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: var(--ts-primary);
  width: 100%;
}

.sidebar-scroll {
  height: auto;
  overflow: auto;
  width: 250px;
  transition: width 0.3s ease;
}

.collapse {
  margin-left: 50px;
  margin-top: 0px;
  padding: 0px;
}

.setup {
  margin-left: 0px;
  margin-top: 20px;
}

.setup:hover {
  color: var(--ts-primary);
  cursor: pointer;
}

.adminActivities {
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  margin-top: 20px;
  color: white;
}

.hide {
  display: none !important;
}

.sidebar-icon-only .sidebar-list-items {
  width: 50px;
}

.sidebar-icon-only .link-text, .sidebar-icon-only .adminActivities {
  display: none;
}

.sidebar-icon-only .sidebar-scroll {
  width: 50px;
}

.admin-layout-container {
  display: flex;
  width: 100%;
  align-items: stretch;
  min-height: calc(100vh - 64px);
}

.admin-layout-sidebar {
  flex: 0 0 250px;
  width: 250px;
  max-width: 250px;
  transition: flex-basis 0.3s ease, width 0.3s ease, max-width 0.3s ease;
}

body.sidebar-icon-only .admin-layout-sidebar {
  position: fixed;
  left: 0;
  top: 64px;
  bottom: 0;
  z-index: 999;
  flex: 0 0;
  width: 50px;
  max-width: 50px;
}

body.sidebar-icon-only .admin-layout-main {
  flex: 1 1 100%;
  width: 100%;
  max-width: 100%;
  padding-left: 50px;
  box-sizing: border-box;
}

.admin-layout-main {
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin: 0;
}

.sidebar-icon-only .collapse {
  margin-left: 0px;
}

.zindex99 {
  z-index: 99 !important;
}

.right-side {
  transform: rotateY(180deg);
}

.left-side {
  transform: rotateY(0deg);
}

.sidebar_new_link {
  color: white !important;
}
.sidebar_new_link:hover {
  text-decoration: none;
}
.sidebar_new_link:hover .sidebar-list-item {
  background: white !important;
  border-radius: 20px !important;
  color: var(--ts-primary) !important;
  max-width: 260px !important;
}
.sidebar_new_link:hover .sidebar-list-item .link-text {
  color: var(--ts-primary) !important;
}

.active-nav-item .sidebar-list-item {
  background: white !important;
  border-radius: 20px !important;
}
.active-nav-item .sidebar-list-item .link-text {
  color: var(--ts-primary) !important;
}

.text-light {
  color: white !important;
}

.admin-activity-text {
  color: white !important;
}

@media screen and (max-width: 991px) {
  .mobile-admin-activities .admin-activity-text {
    color: #000000 !important;
  }
  .mobile-admin-activities .admin-activity-text .link-text {
    color: #000000 !important;
    display: inline-block !important;
  }
  .mobile-admin-activities .sidebar_new_link.admin-activity-text {
    color: #000000 !important;
  }
  .mobile-admin-activities .sidebar_new_link.admin-activity-text:hover .sidebar-list-item {
    background: transparent !important;
    color: #000000 !important;
    padding: 2px;
  }
  .mobile-admin-activities .sidebar_new_link.admin-activity-text:hover .sidebar-list-item .link-text {
    color: #000000 !important;
  }
  .mobile-admin-activities .adminActivities {
    color: #000000 !important;
    display: inline-block !important;
    padding: 0px;
    margin: 0px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/styles.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,UAAA;EACA,gBAAA;AACF;;AACA;EACE,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;EACA,6BAAA;AAEF;;AAAA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;AAGF;;AAAA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AAGF;;AADA;EACE,uBAAA;AAIF;;AAFA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,mCAAA;EACA,WAAA;AAKF;;AAHA;EACE,YAAA;EACA,cAAA;EACA,YAAA;EACA,2BAAA;AAMF;;AAJA;EACE,iBAAA;EACA,eAAA;EACA,YAAA;AAOF;;AALA;EACE,gBAAA;EACA,gBAAA;AAQF;;AANA;EACE,wBAAA;EACA,eAAA;AASF;;AAPA;EACE,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AAUF;;AARA;EACE,wBAAA;AAWF;;AATA;EACE,WAAA;AAYF;;AAVA;EACE,aAAA;AAaF;;AAXA;EACE,WAAA;AAcF;;AAXA;EACE,aAAA;EACA,WAAA;EACA,oBAAA;EACA,8BAAA;AAcF;;AAXA;EACE,eAAA;EACA,YAAA;EACA,gBAAA;EACA,sEAAA;AAcF;;AAXA;EACE,eAAA;EACA,OAAA;EACA,SAAA;EACA,SAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;AAcF;;AAXA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;AAcF;;AAXA;EACE,cAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,SAAA;AAcF;;AAXA;EACE,gBAAA;AAcF;;AAXA;EACE,sBAAA;AAcF;;AAZA;EACE,0BAAA;AAeF;;AAZA;EACE,wBAAA;AAeF;;AAZA;EACE,uBAAA;AAeF;AAbE;EACE,qBAAA;AAeJ;AAbI;EACE,4BAAA;EACA,8BAAA;EACA,mCAAA;EACA,2BAAA;AAeN;AAbM;EACE,mCAAA;AAeR;;AARE;EACE,4BAAA;EACA,8BAAA;AAWJ;AATI;EACE,mCAAA;AAWN;;AANA;EACE,uBAAA;AASF;;AANA;EACE,uBAAA;AASF;;AALA;EAEI;IACE,yBAAA;EAOJ;EANI;IACE,yBAAA;IACA,gCAAA;EAQN;EAJE;IACE,yBAAA;EAMJ;EAHM;IACE,kCAAA;IACA,yBAAA;IACA,YAAA;EAKR;EAJQ;IACE,yBAAA;EAMV;EAAE;IACE,yBAAA;IACA,gCAAA;IACA,YAAA;IACA,WAAA;EAEJ;AACF","sourcesContent":[".sidebar-list-items {\n  margin: 0;\n  padding: 0;\n  margin-top: 10px;\n}\n.sidebar-list-item {\n  list-style-type: none;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  font-size: 14px;\n  margin-right: 1rem !important;\n}\n.sidebar-list-icon {\n  width: 15px;\n  height: 15px;\n  margin: 0 10px 0 10px;\n}\n\n.sidebar-list-icon--component {\n  width: auto;\n  height: auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n.user-dropdown {\n  width: 200px !important;\n}\n.sidebar{\n  position: fixed;\n  top:0;\n  left:0;\n  z-index: 999;\n  background-color: var(--ts-primary);\n  width:100%;\n}\n.sidebar-scroll{\n  height:auto;\n  overflow: auto;\n  width:250px;\n  transition: width 0.3s ease;\n}\n.collapse{\n  margin-left:50px;\n  margin-top:0px;\n  padding:0px;\n}\n.setup{\n  margin-left:0px;\n  margin-top:20px;\n}\n.setup:hover{\n  color: var(--ts-primary);\n  cursor: pointer;\n}\n.adminActivities{\n  font-style: normal;\n  font-weight: bold;\n  font-size: 18px;\n  margin-top: 20px;\n  color: white;\n}\n.hide{\n  display: none!important;\n}\n.sidebar-icon-only .sidebar-list-items{\n  width:50px;\n}\n.sidebar-icon-only .link-text,.sidebar-icon-only .adminActivities{\n  display: none;\n}\n.sidebar-icon-only .sidebar-scroll{\n  width:50px;\n}\n\n.admin-layout-container {\n  display: flex;\n  width: 100%;\n  align-items: stretch;\n  min-height: calc(100vh - 64px);\n}\n\n.admin-layout-sidebar {\n  flex: 0 0 250px;\n  width: 250px;\n  max-width: 250px;\n  transition: flex-basis 0.3s ease, width 0.3s ease, max-width 0.3s ease;\n}\n\nbody.sidebar-icon-only .admin-layout-sidebar {\n  position: fixed;\n  left: 0;\n  top: 64px;\n  bottom: 0;\n  z-index: 999;\n  flex: 0 0 0;\n  width: 50px;\n  max-width: 50px;\n}\n\nbody.sidebar-icon-only .admin-layout-main {\n  flex: 1 1 100%;\n  width: 100%;\n  max-width: 100%;\n  padding-left: 50px;\n  box-sizing: border-box;\n}\n\n.admin-layout-main {\n  flex: 1 1 auto;\n  min-width: 0;\n  width: 100%;\n  max-width: 100%;\n  padding: 0;\n  margin: 0;\n}\n\n.sidebar-icon-only .collapse{\n  margin-left: 0px;\n}\n\n.zindex99{\n  z-index: 99!important;\n}\n.right-side{\n  transform: rotateY(180deg);\n}\n\n.left-side{\n  transform: rotateY(0deg);\n}\n\n.sidebar_new_link {\n  color: white !important;\n  \n  &:hover {\n    text-decoration: none;\n    \n    .sidebar-list-item {\n      background: white !important;\n      border-radius: 20px !important;\n      color: var(--ts-primary) !important;\n      max-width: 260px !important;\n      \n      .link-text {\n        color: var(--ts-primary) !important;\n      }\n    }\n  }\n}\n\n.active-nav-item {\n  .sidebar-list-item {\n    background: white !important;\n    border-radius: 20px !important;\n    \n    .link-text {\n      color: var(--ts-primary) !important;\n    }\n  }\n}\n\n.text-light {\n  color: white !important;\n}\n\n.admin-activity-text {\n  color: white !important;\n}\n\n// Mobile styles - make admin activities black in navbar\n@media screen and (max-width: 991px) {\n  .mobile-admin-activities {\n    .admin-activity-text {\n      color: #000000 !important;\n      .link-text {\n        color: #000000 !important;\n        display: inline-block !important;\n      }\n    }\n    \n    .sidebar_new_link.admin-activity-text {\n      color: #000000 !important;\n\n      &:hover {\n        .sidebar-list-item {\n          background: transparent !important;\n          color: #000000 !important;\n          padding:2px;\n          .link-text {\n            color: #000000 !important;\n          }\n        }\n      }\n    }\n    \n    .adminActivities {\n      color: #000000 !important;\n      display: inline-block !important;\n      padding:0px;\n      margin:0px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
